import modelsListMiddleware from './models_list';

export default [...modelsListMiddleware];
